module.exports = __webpack_public_path__ + "static/media/hearth-icon.8fcbb19c.png";